import salesImage from "../assets/projects/sales.png";
import vendingImage from "../assets/projects/vending.png";
import handymanImage from "../assets/projects/handyman.jpg";
import sales1 from "../assets/projects/sales1.jpeg";
import sales2 from "../assets/projects/sales2.jpeg";
import sales3 from "../assets/projects/sales3.jpeg";
import sales4 from "../assets/projects/sales4.jpeg";
import sales5 from "../assets/projects/sales5.jpeg";
import sales6 from "../assets/projects/sales6.jpeg";
import vending2 from "../assets/projects/vending.jpeg";
import vending3 from "../assets/projects/vending3.png";
import vending4 from "../assets/projects/vending4.png";
import architecture from "../assets/projects/architecture.png";
import deivery1 from "../assets/projects/delivery1.png";
import delivery2 from "../assets/projects/delivery2.png";
import delivery3 from "../assets/projects/delivery3.png";
import tapon1 from "../assets/projects/tapon1.jpeg";
import tapon2 from "../assets/projects/tapon2.jpeg";
import tapon3 from "../assets/projects/tapon3.jpeg";
import tapon4 from "../assets/projects/tapon4.jpeg";

const projectList = [
  {
    slug: "pegas-go-sales-app",
    title: "Pegas Sales Partner App",
    tagline: "Multi-shop sales platform with real-time order intelligence",
    type: "User + Admin",
    
    statusTone: "ready",
    role: "App Developer",
    highlights: ["Realtime sales", "Field sales automation", "Multi-tenant"],
    overview: {
      problem:
        "Sales teams lacked a unified, realtime view of orders, inventory, and delivery status across multiple shops.",
      solution:
        "A mobile-first sales suite with live order tracking",
      users: "sales reps",
    },
    features: [
      "Role-based access for admin, seller, and delivery",
      "Live order pipeline with smart status updates",
      "Secure authentication and data isolation per user",
    ],
    stack: {
      frontend: ["Flutter", "Firebase"],
      backend: ["Firebase"],
      database: ["Firestore"],
      tools: ["Git", "Figma", "VS code"],
    },
    architectureFlow: [
      "Flutter app authenticates users",
      "Orders stored in Firestore",
      "Firestore process workflows",
      "Dashboards sync in realtime",
    ],
    challengesSolutions: [
      {
        challenge: "Realtime sync across multiple devices",
        solution: "Optimized Firestore queries and conflict-safe updates",
      },
      {
        challenge: "Offline order capture",
        solution: "Local caching with background sync queues",
      },
    ],
    gallery: [sales4, sales3, sales1, sales2,sales5,sales6],
    impact: [
      "Sales reps can earn extra income and businesses in their area become wider known and have more customers",
   
    ],
    technologies: "Flutter, Firebase",
    architecture: "Flutter client + Firebase auth, Firestore data, serverless functions for workflows",
    challenges: "Realtime sync across multiple devices while preserving data integrity and fast UX.",
    results: "Reduced order processing time and improved sales visibility for every store manager.",
    image: salesImage,    tech: ["flutter", "firebase", "figma"],
    repo: "https://github.com/RishafH/PegasGoSales",
    live: "https://www.linkedin.com/feed/update/urn:li:activity:7459166405117124608/"
  },
   {
    slug: "pegas-delivery-partner-app",
    title: "Pegas Delivery Partner App",
    tagline: "Efficient delivery management",
    type: "Mobile App",
    status: "In Progress",
    statusTone: "progress",
    role: "App Developer",
    highlights: ["Fast", "Organized", "Efficient Deliveries"],
    overview: {
      problem:
        "Many businesses struggle to find reliable delivery workers when orders need to be delivered. At the same time, delivery workers also struggle to find available delivery jobs consistently.",
      solution:
        "Our Delivery Management App connects businesses with delivery workers through a simple digital platform.Businesses can quickly assign delivery orders, while delivery workers can easily find available delivery tasks and earn income.",
      users: "Part Time Workers,Businesses, Wholesale Companies,Delivery Workers,Delivery Coordinators,Sales & Distribution Teams",
    },
    features: [
      
"Find delivery workers easily",
"Assign orders quickly",
"Track delivery progress",
"Manage delivery operations digitally",

"Find delivery opportunities",
"Receive delivery requests instantly",
"Manage assigned deliveries",
"Earn through completed deliveries",
"Real-time order updates"

    
    ],
    stack: {
      frontend: ["Flutter", "Dart","Open Street Map"],
      backend: [ "Firebase"],
      database: ["Firebase Storage"],
      tools: ["Figma", "Git"],
    },
    architectureFlow: [
    
    ],
    challengesSolutions: [
   
    ],
    gallery: [deivery1, delivery2, delivery3],
    impact: [
      " Connecting Businesses With Delivery Workers Smarter & Faster."
    ],
    technologies: "Flutter,  Firebase",
    architecture: "Flutter client + Firebase backend with real-time updates and geolocation integration",
    architectureImage: architecture,
    challenges: "Coordinating real-time order updates and geolocation tracking for efficient deliveries.",
    results: "Streamlined delivery operations and improved connectivity between businesses and delivery workers.",
    image: deivery1,
    tech: ["flutter", "firebase", ],
    repo: "",
    live: ""
  },
  {
    slug: "vending-machine-app",
    title: "Vending Machine App",
    tagline: "Smart vending experience with live stock and cashless flows",
    type: "Mobile App",
    status: "Completed",
    statusTone: "done",
    role: "App Developer",
    highlights: ["Live inventory", "Kiosk-ready"],
    overview: {
     
      solution:
        "An intelligent vending solution that brings a seamless and enjoyable self-service experience to users.",
      users: "People on the go looking for quick snacks and beverages",
    },
    features: [
      "Product catalog synced with inventory",
      
      "Admin control for stock updates",
     
    ],
    stack: {
      frontend: ["Flutter", "Dart", "TTS"],
      backend: ["Firebase Realtime DB"],
      database: ["Realtime Database"],
      tools: ["Figma"],
    },
    architectureFlow: [
      "Kiosk app fetches realtime inventory",
      "Purchase events update stock",
      "Admin console syncs updates",
    ],
   
    gallery: [vending2, vendingImage, vending3,vending4],
    impact: [
      "Eliminated out-of-stock purchase failures",
      "Improved kiosk speed and completion rates",
      "Simplified operator stock management",
    ],
    technologies: "Flutter, Firebase Realtime Database",
    architecture: "Flutter client + Firebase realtime data + modular state management",
    challenges: "Ensuring UI responsiveness while handling frequent inventory updates.",
    results: "Eliminated out-of-stock failures and improved purchase completion rates.",
    image: vendingImage,
    tech: ["flutter", "firebase"],
    repo: "",
    live: ""
  },
  {
    slug: "tapon-handyman-app",
    title: "TapOn Handyman App",
    tagline: "On-demand home services with live booking and tracking",
    type: "Mobile App for multi-role users",
    status: "Completed",
    statusTone: "done",
    role: "University Group Project",
    highlights: ["Live booking", "Provider matching", "Route tracking"],
    overview: {
      problem:
        "Service marketplaces lacked transparent booking updates and fast provider matching.",
      solution:
        "A multi-role platform for booking, provider routing, and service history.",
      users: "Customers, service providers, Tool providers",
    },
    features: [
      "Multi-role flow for customer, provider",
      "Scheduling and live service tracking",
      "Ratings, profiles, and verified providers",
      "Service history with invoices",
    ],
    stack: {
      frontend: ["Flutter", "Dart"],
      backend: ["Node.js", "Express"],
      database: ["MongoDB"],
      tools: ["Figma", "Postman"],
    },
    architectureFlow: [
      "Flutter app authenticates roles",
      "Node API handles bookings",
      "MongoDB stores service history",
      "Realtime updates via Webhooks",
    ],
    challengesSolutions: [
      {
        challenge: "Coordinating multiple roles",
        solution: "Role-based access and status workflows",
      },
      {
        challenge: "Transparent job tracking",
        solution: "Realtime status updates and notifications",
      },
    ],
    gallery: [handymanImage, tapon1,tapon2,tapon3,tapon4],
    impact: [
      "Reduced booking friction",
      "Improved provider response time",
      "Higher user trust with transparent updates",
    ],
    technologies: "Flutter, Node.js, MongoDB, REST APIs",
    architecture: "Flutter client + Node.js API + MongoDB, role-based authorization",
    challenges: "Coordinating real-time status updates between multiple roles.",
    results: "Reduced booking friction and increased provider response rates.",
    image: handymanImage,
    tech: ["flutter", "node", "mongo", "figma", "git"],
    repo: "https://github.com/RishafH/TapOn",
    live: ""
  }
];

export default projectList;
